import React from 'react'
import Dots from '../dots/Dots'
import './headersection.css'

const HeaderSection = ({title}) => {

      return (
            <div className="header_section flex">
                  <h2>{title}</h2>
                  <Dots/>
            </div>
      )
}

export default HeaderSection
